module.exports = new __parcel__URL__("Marketing Campaign.45dd758d.svg").toString();